import { NgModule } from '@angular/core';
import { RapidAngularComponent } from './rapid-angular.component';
import { ButtonComponent } from './button/button.component';



@NgModule({
  declarations: [RapidAngularComponent, ButtonComponent],
  imports: [
  ],
  exports: [RapidAngularComponent, ButtonComponent]
})
export class RapidAngularModule { }
